import {mapGetters} from 'vuex'
import cardJourney from 'js/components/journeys/cards/journey'
import cardProduct from '../components/journeys/cards/product'

export default {
  data() {
    return {}
  },
  components: {
    cardJourney,
    cardProduct
  },
  computed: {
    ...mapGetters('user', ['products']),
    ...mapGetters(['getUserLanguage'])
  },
  methods: {
    tripDate(trip, basic = false) {
      const data = _.head(trip)
      const d = moment(data.operation_date)

      if (basic) return d.format('YYYY-MM-DD')

      const dateParts = d.format('LLLL').split(' ')
      const lang = this.getUserLanguage
      switch (lang) {
        case 'es':
        case 'pt':
          return dateParts.slice(0, 6).join(' ')
        default:
          return dateParts.slice(0, 4).join(' ')
      }
    },
    tripTime(trip, basic = false) {
      const d = moment(trip.operation_date)

      return basic ? d.format('HH:mm') : `${this.$t('dates.time')}: ${d.format('HH:mm')}`
    },

    tripZone(trip) {
      if (!this.$administrativeArea?.config?.has_combination_code || !trip?.crossed_areas) return ''

      return `${this.$t('travels.zone')} ${trip.crossed_areas}`
    },

    tripRouteText(trip) {
      if (trip?.route?.origin && trip?.route?.destination) {
        return `${trip.route.origin} - ${trip.route.destination}`
      }

      return trip?.stop?.name || trip?.origin_stop_name || ''
    }
  }
}
